// extracted by mini-css-extract-plugin
module.exports = {"Photos":"Photos_Photos__BXhg3"};